import ms from 'ms'

const second = ms('1s')

/** Caps simulation steps when the tab stalls. */
export const maxFrameDeltaSeconds = ms('50ms') / second

/** Demand-render cadence while a gesture or move is playing. */
export const activeFrameIntervalMs = ms('1s') / 60

export const idleGestureDurationMs = {
  blink: ms('320ms'),
  glance: ms('1.6s'),
  peek: ms('2.7s'),
  hover: ms('1.2s'),
  complete: ms('2.4s'),
} as const

export const idleScheduleMs = {
  blink: { base: ms('4s'), jitter: ms('3s') },
  glance: { base: ms('8s'), jitter: ms('4s') },
  peek: { base: ms('20s'), jitter: ms('10s') },
} as const

export const movePoseBlendSeconds = ms('140ms') / second

export const shapeMorphDurationSeconds = ms('300ms') / second
